import { createNotification } from "react-redux-notify";
import { select, put, takeLatest, all, takeEvery } from "redux-saga/effects";

import {
  SAVE_POST_LIKE_START,
  FETCH_POST_LIKED_START,
} from "../actions/ActionConstant";
import api from "../../Environment";
import {
  getErrorNotificationMessage,
  getSuccessNotificationMessage,
} from "../../components/helper/NotificationMessage";
import {
  savePostLikeFailure,
  savePostLikeSuccess,
  fetchPostLikedSuccess,
  fetchPostLikedFailure,
} from "../actions/PostLikesAction";
import ErrorUtils from "../../helpers/utils/errors";
import { updatePostLikes } from "../actions/HomeAction";
import { updateOtherUserPostLikes } from "../actions/OtherUserAction";
import { updateSinglePostLikes, updateUserPostLikes } from "../actions/PostAction";
import { updateBookmarkPostLikes } from "../actions/BookmarkAction";
import { showErrorComponent } from "../actions/ComponentAction";

function* savePostLikesAPI() {
  try {
    const inputData = yield select(
      (state) => state.postLike.saveLike.inputData
    );
    const response = yield api.postMethod("post_likes_save", inputData);
    if (response.data.success) {
      // update post like count
      yield put(updatePostLikes(response.data.data));
      yield put(updateOtherUserPostLikes(response.data.data))
      yield put(updateUserPostLikes(response.data.data))
      yield put(updateSinglePostLikes(response.data.data))
      yield put(updateBookmarkPostLikes(response.data.data))
      yield put(savePostLikeSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(savePostLikeFailure(response.data.error));
      const { notify, message } = ErrorUtils.handleApiError(response.data)
      if (notify) {
        yield put(createNotification(getErrorNotificationMessage(message)));
      }
    }
  } catch (error) {
    yield put(savePostLikeFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchPostLikesAPI() {
  try {
    const inputData = yield select(
      (state) => state.postLike.saveLike.inputData
    );
    const response = yield api.postMethod("post_likes", inputData);
    if (response.data.success) {
      yield put(fetchPostLikedSuccess(response.data.data));
    } else {
      yield put(fetchPostLikedFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchPostLikedFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

export default function* pageSaga() {
  yield all([yield takeEvery(SAVE_POST_LIKE_START, savePostLikesAPI)]);
  yield all([yield takeLatest(FETCH_POST_LIKED_START, fetchPostLikesAPI)]);
}
